import React from 'react';
import IconButton from 'components/common/IconButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
const MyVisitsTableHeader = ({
  toggelModal,
  custType,
  toggelFilter,
  isFromManagerPage = false
}) => {
  const buildTitle = () => {
    if (isFromManagerPage) {
    return ''
    }
  };
  return (
    <div>
      <FalconCardHeader
        title={buildTitle(custType, isFromManagerPage)}
        light
        titleTag="h6"
        endEl={
          <div
            id="orders-actions"
            className="d-flex align-items-center justify-content-between"
          >
            {!isFromManagerPage && (
              <IconButton
                variant="falcon-default"
                size="md"
                icon="plus"
                transform="shrink-2"
                onClick={toggelModal}
                className="ms-2"
              >
                <span className="d-none d-sm-inline-block ms-1">New</span>
              </IconButton>
            )}
            {/* <div className="d-flex align-items-center ms-2">
              <BaseDropdownV2
                fieldName="customerTypeId"
                placeholder="Customer Type"
                handleChange={(e, v) => setCustType(v.value)}
                isMulti={false}
                closeMenuOnSelect={true}
                getSource={getCustomerTypes}
                // sourceParam={param}
                mapToOption={res => {
                  console.log(res);
                  return res?.data.items.map(i => {
                    return { ...i, value: i.value, label: i.display };
                  });
                }}
                value={custType ?? 0}
              />
            </div> */}

            {isFromManagerPage && (
              <div className="d-flex align-items-center ms-2">
                <IconButton
                  variant="falcon-default"
                  size="md"
                  icon="filter"
                  transform="shrink-3"
                  className="mx-2"
                  onClick={toggelFilter}
                >
                  <span className="d-none d-sm-inline-block ms-1">Filter</span>
                </IconButton>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

MyVisitsTableHeader.propTypes = {
  toggelFilter: PropTypes.func,
  handleSearch: PropTypes.func,
  toggelModal: PropTypes.func,
  isFromManagerPage: PropTypes.bool,
  custType: PropTypes.number,
  setCustType: PropTypes.func,
};

export default MyVisitsTableHeader;
